import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import NotificationService from "@/services/notification.service";
import { ModalStatus } from "@/constants/modal";
import { LogLevel, LogService } from "@/services/logging";
import { getSalesConfigurationById } from "@/api/gql/sales-configurations";
import { toLocalPOSConfig, loadConfigData } from "@/utils/helpers/pos-config";
import { proceedFetchAndStoreGroupPicture } from "@/utils/helpers/product-category";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "ReloadConfiguration",
  setup: function setup() {
    console.log("hi from reloadConfig");

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var modalVisibility = dialogVisibleForStatus(ModalStatus.ReloadConfiguration);
    var getLoadingText = computed(function () {
      return POSConfigModule.getLoadingText;
    });
    var progressValue = computed(function () {
      var pcsProgress = POSConfigModule.pcsLoaded;
      var timeslotsProgress = POSConfigModule.timeslotsLoaded;

      if (pcsProgress > 50 || timeslotsProgress) {
        // Cap PCs progress at 50 once timeslots start loading
        pcsProgress = 50;
      }

      if (timeslotsProgress > 35) {
        // Cap timeslots progress at 35
        timeslotsProgress = 35;
      } // extraProgress covers the remaining 5% (seating plans, promotions, offers, locations)


      return 10 + pcsProgress + timeslotsProgress + POSConfigModule.extraProgress;
    }); // reload the current selected config

    function reloadConfig() {
      return _reloadConfig.apply(this, arguments);
    }

    function _reloadConfig() {
      _reloadConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedConfig, refreshedConfig, convertedConfig, success;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return POSConfigModule.fetchGroupInfo();

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                LogService.info("Error while fetching Group Info", _context2.t0, LogLevel.Error);

              case 8:
                _context2.next = 10;
                return proceedFetchAndStoreGroupPicture();

              case 10:
                // refresh the selected config data from backend as well
                selectedConfig = POSConfigModule.selectedConfig;

                if (selectedConfig) {
                  _context2.next = 14;
                  break;
                }

                // If no selected config then we don't reload
                LogService.info("There is no selected config to be reloaded", undefined, LogLevel.Error);
                return _context2.abrupt("return");

              case 14:
                _context2.prev = 14;
                _context2.next = 17;
                return getSalesConfigurationById(selectedConfig.id);

              case 17:
                refreshedConfig = _context2.sent;
                convertedConfig = toLocalPOSConfig(refreshedConfig[0]);
                POSConfigModule.SET_SELECTED_CONFIG(_objectSpread({}, convertedConfig)); // clear the selected grid

                POSConfigModule.selectGrid(null);
                _context2.next = 23;
                return loadConfigData(convertedConfig);

              case 23:
                success = _context2.sent;

                if (success) {
                  setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            // It is sure that every data from remote to start selling is now pulled and stored in local db
                            // lets create a new booking if sales has already started
                            if (hasSalesStarted.value) {
                              console.log("******** calling BookingModule.createNewBooking");
                              BookingModule.createNewBooking();
                            }

                            hideDialog();
                            POSConfigModule.setPCsLoaded(0);
                            POSConfigModule.setTimeslotsLoaded(0);
                            POSConfigModule.setExtraProgress(0);

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  })), 500);
                }

                _context2.next = 32;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t1 = _context2["catch"](14);
                hideDialog();
                LogService.info("Error while refetching selected config", _context2.t1, LogLevel.Error);
                NotificationService.showGeneralResponseError();

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5], [14, 27]]);
      }));
      return _reloadConfig.apply(this, arguments);
    }

    return {
      t: t,
      modalVisibility: modalVisibility,
      progressValue: progressValue,
      reloadConfig: reloadConfig,
      getLoadingText: getLoadingText
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var selectedConfig;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // refresh the selected config data from backend as well
              selectedConfig = POSConfigModule.selectedConfig;

              if (!selectedConfig) {
                // If no selected config then we don't reload
                LogService.info("There is no selected config to be reloaded", undefined, LogLevel.Error);
                hideDialog();
              } else {
                _this.reloadConfig();
              }

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
});